var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatbell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43555 12.0001C5.54868 12.3248 5.76008 12.6063 6.04041 12.8055C6.32073 13.0047 6.6561 13.1117 6.99999 13.1117C7.34388 13.1117 7.67925 13.0047 7.95958 12.8055C8.23991 12.6063 8.4513 12.3248 8.56444 12.0001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.888672 9.77792H13.1109",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1109 9.7779C12.5344 9.73867 11.9917 9.49195 11.5832 9.0834C11.1746 8.67484 10.9279 8.13212 10.8887 7.55567V4.7779C10.8887 3.7465 10.479 2.75734 9.74964 2.02804C9.02033 1.29873 8.03118 0.889008 6.99978 0.889008V0.889008C5.96839 0.889008 4.97923 1.29873 4.24992 2.02804C3.52061 2.75734 3.11089 3.7465 3.11089 4.7779V7.55567C3.07167 8.13212 2.82495 8.67484 2.41639 9.0834C2.00784 9.49195 1.46512 9.73867 0.888672 9.7779",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbell);
export default __webpack_public_path__ + "static/media/chatbell.c370e19253cb269950f28f41650449b9.svg";
export { ForwardRef as ReactComponent };